import { render, staticRenderFns } from "./DecorationSlider.vue?vue&type=template&id=0e4de820&"
import script from "./DecorationSlider.vue?vue&type=script&lang=ts&"
export * from "./DecorationSlider.vue?vue&type=script&lang=ts&"
import style0 from "./DecorationSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports